(() => {
  // Capture swatch clicks BEFORE legacy jQuery handlers.
  // After selecting a color swatch, hover swap (desktop) + swipe (mobile)
  // should show the 2nd image for the CURRENT selected color (ES-like).

  const norm = (u) => String(u || '')
    .replace(/^https?:/,'')
    .split('?')[0]
    .trim();

  
  const upgradeUrl = (url, targetWidth = 1200) => {
    let u = String(url || '');
    if (!u) return u;

    // Prefer width query param if present
    u = u.replace(/([?&]width=)(\d+)/i, `$1${targetWidth}`);

    // Shopify size suffixes can look like: _360x.jpg, _360x360.jpg, _grande.jpg, _master.jpg
    // We normalize all of those to a higher-res _{targetWidth}x before the file extension.
    u = u
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.(?:jpg|jpeg|png|webp|gif))/i, `_${targetWidth}x`)
      .replace(/_(\d+)(x(\d+))?x?(?=\.(?:jpg|jpeg|png|webp|gif))/i, `_${targetWidth}x`);

    return u;
  };
const getImageList = (card) => {
    const listStr = (card && card.dataset && card.dataset.esImagelist) ? card.dataset.esImagelist : '';
    if (!listStr) return [];
    return listStr.split('||').map((s) => String(s).trim()).filter(Boolean);
  };

  const pickAlt = (card, img1, img2) => {
    if (img2) return img2;
    const list = getImageList(card);
    if (!list.length || !img1) return '';

    const n1 = norm(img1);
    let idx = -1;
    for (let i = 0; i < list.length; i++) {
      if (norm(list[i]) === n1) {
        idx = i;
        break;
      }
    }

    // Preferred: next image after img1
    if (idx > -1 && idx + 1 < list.length) return list[idx + 1];

    // Fallback: first different image in list
    for (let j = 0; j < list.length; j++) {
      if (norm(list[j]) !== n1) return list[j];
    }
    return '';
  };

  const setImg = (img, url) => {
    if (!img || !url) return;
    try {
      img.setAttribute('src', url);
      img.setAttribute('data-src', url);

      // Remove responsive/lazy artifacts so the swapped image renders crisp.
      ['srcset','data-srcset','sizes','data-sizes'].forEach((a) => {
        try { img.removeAttribute(a); } catch(_) {}
      });

      if (img.classList) {
        img.classList.remove('lazyload', 'lazyloading');
        img.classList.add('lazyloaded');
      }
      if (img.style) img.style.filter = 'none';
    } catch(e) {}
  };

  const fadeSwapImg = (img, url) => {
    if (!img || !url) return;
    const u = upgradeUrl(url, 1200);

    try {
      img.style.transition = img.style.transition || 'opacity .22s ease';
      img.style.opacity = '0.15';
    } catch(e) {}

    preloadThen(u, () => {
      setImg(img, u);
      requestAnimationFrame(() => {
        try { img.style.opacity = '1'; } catch(e) {}
      });
    });
  };

  const ensureSecondary = (card) => {
    let secondary = card.querySelector('img.engo-secondary-image');
    if (secondary) return secondary;

    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const anchor = card.querySelector('a.engoj_find_img.engo-hover-swap') || card.querySelector('a.engoj_find_img');
    if (!primary || !anchor) return null;

    secondary = document.createElement('img');
    secondary.className = 'lazyload img-responsive engo-secondary-image';
    secondary.alt = primary.getAttribute('alt') || '';
    secondary.style.width = '100%';
    anchor.appendChild(secondary);
    return secondary;
  };

  const updateSwipe = (card, img1, img2) => {
    const swipe = card.querySelector('[data-es-swipe]');
    if (!swipe) return;
    const imgs = swipe.querySelectorAll('img.es-swipe-img');
    if (imgs.length > 0 && img1) setImg(imgs[0], img1);
    if (imgs.length > 1 && img2) setImg(imgs[1], img2);

    // reset to first slide
    try { swipe.scrollLeft = 0; } catch(_) {}
    try { swipe.dispatchEvent(new Event('scroll')); } catch(_) {}
  };

  const updateIndicator = (card, enabled) => {
    const indicator = card.querySelector('.es-swipe-indicator');
    if (!indicator) return;
    if (enabled) indicator.classList.remove('is-hidden');
    else indicator.classList.add('is-hidden');
  };

  const setActive = (a) => {
    const wrap = a.closest('.engoj_select_color');
    if (!wrap) return;

    // Toggle active state on anchors (used by existing theme styles/scripts)
    wrap.querySelectorAll('a').forEach((el) => el.classList.remove('active'));
    a.classList.add('active');

    // Toggle active state on the wrapper <span class="border_thumbnail"> so our underline is reliable
    wrap.querySelectorAll('.border_thumbnail').forEach((el) => el.classList.remove('is-active'));
    const parentThumb = a.closest('.border_thumbnail');
    if (parentThumb) parentThumb.classList.add('is-active');
  };

  const handleSwatchClick = (a) => {
    const card = a.closest('.engoj_grid_parent') || a.closest('.product') || a.closest('[data-es-imagelist]');
    if (!card) return;

    setActive(a);

    // ES: Keep wishlist button bound to the selected variant (per-variant wishlist)
    try {
      const vid = a.getAttribute('data-es-variant-id') || (a.dataset && a.dataset.esVariantId) || '';
      if (vid) {
        const btn = card.querySelector('button.es-wishlist-btn');
        if (btn) {
          btn.setAttribute('data-variant-id', vid);
          try { btn.dataset.variantId = vid; } catch(e) {}

          // ES FIX (2026-01-29): We do NOT re-initialize Swym on swatch changes.
          // Our wishlist click handler reads the current data-variant-id at click time.
          // So here we only re-apply visual state for the newly selected variant.
          if (window.esWishlistApplyToButton) window.esWishlistApplyToButton(btn);
        }
      }
    } catch(e) {}

    const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
    const img2raw = a.getAttribute('data-engojvariant-img2') || a.dataset.engojvariantImg2 || '';
    const img2 = pickAlt(card, img1, img2raw) || img2raw;

    const img1Large = upgradeUrl(img1, 1200);
    const img2Large = upgradeUrl(img2, 1200);

    // Desktop images
    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const secondary = ensureSecondary(card);

    if (primary && img1Large) fadeSwapImg(primary, img1Large);
    if (secondary && img2Large) fadeSwapImg(secondary, img2Large);

    // Mobile swipe images + indicator
    updateSwipe(card, img1Large, img2Large);
    const enabled = !!(img2Large && norm(img2Large) !== norm(img1Large));
    updateIndicator(card, enabled);
  };

  // Use capture phase so we run before any legacy jQuery click handlers.
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('.engoj_select_color a') : null;
    if (!a) return;

    handleSwatchClick(a);

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }, true);

  /* =========================================================
     Hover preview (temporary) — desktop only
     - Hover is NOT a selection; click still selects.
     - Adds animated gold line + swaps the main image for fast browsing.
     ========================================================= */

  const canHoverPreview = (() => {
    try {
      return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    } catch (e) {
      return false;
    }
  })();

  const extractBgUrl = (el) => {
    if (!el) return '';
    const bg = (el.style && el.style.backgroundImage) ? el.style.backgroundImage : '';
    if (!bg) return '';
    const m = bg.match(/url\((['"]?)(.*?)\1\)/i);
    return m ? m[2] : '';
  };

  const preloadThen = (url, cb) => {
    if (!url || typeof cb !== 'function') return;
    const img = new Image();
    img.onload = () => cb(url);
    img.onerror = () => cb(url);
    img.src = url;
  };

  const findCard = (el) => {
    return el.closest('.engoj_grid_parent') || el.closest('.product') || el.closest('[data-es-imagelist]');
  };

  const applyImagesFromAnchor = (card, a) => {
    if (!card || !a) return;
    const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
    const img2raw = a.getAttribute('data-engojvariant-img2') || a.dataset.engojvariantImg2 || '';
    const img2 = pickAlt(card, img1, img2raw) || img2raw;
    const img1Large = upgradeUrl(img1, 1200);
    const img2Large = upgradeUrl(img2, 1200);

    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const secondary = ensureSecondary(card);

    if (primary && img1Large) fadeSwapImg(primary, img1Large);
    if (secondary && img2Large) fadeSwapImg(secondary, img2Large);

    updateSwipe(card, img1Large, img2Large);
    const enabled = !!(img2Large && norm(img2Large) !== norm(img1Large));
    updateIndicator(card, enabled);
  };

  const restoreCardImages = (card) => {
    if (!card) return;
    const active = card.querySelector('.engoj_select_color a.active') || card.querySelector('.engoj_select_color a');
    if (active) applyImagesFromAnchor(card, active);
  };

  const setMainImgs = (scope, url) => {
    if (!scope || !url) return;
    const u = upgradeUrl(url, 1200);

    // Quickview uses a dedicated class
    const qv = scope.closest('.quickview-product');
    if (qv) {
      const main = qv.querySelector('img.engoj_img_main_quickview');
      if (main) fadeSwapImg(main, u);

      // Keep zoom lens (if any) in sync
      try {
        const zqv = qv.querySelector('.zoomLens');
        if (zqv) zqv.style.backgroundImage = 'url("' + u + '")';
      } catch(_) {}

      // Keep Quickview "hover next image" in sync with the temporarily previewed image
      try {
        if (window.jQuery && window.tshopifyQuickview && typeof window.tshopifyQuickview.updateQuickviewHoverSwap === 'function') {
          const $qv = window.jQuery(qv);
          const p = $qv.data('esQvProduct');
          if (p) setTimeout(() => window.tshopifyQuickview.updateQuickviewHoverSwap(p, $qv), 120);
        }
      } catch(_) {}

      return;
    }

    // PDP: update both the main image and the sticky image (theme already does this on variant select)
    document.querySelectorAll('img.engoj_img_main').forEach((img) => fadeSwapImg(img, u));

    // Keep Fancybox href in sync (otherwise clicking main image may open the previous image)
    try {
      document.querySelectorAll('.product-img-box .img-product a.fancybox').forEach(function(a){
        if (a && a.setAttribute) a.setAttribute('href', u);
      });
    } catch(_) {}


    // Keep zoom lens in sync (if present)
    try {
      const z = document.querySelector('.zoomLens');
      if (z) z.style.backgroundImage = 'url("' + u + '")';
    } catch (_) {}

    // Sync PDP "hover next image" with the previewed image
    try {
      if (window.ES_PDP_HoverSwap && typeof window.ES_PDP_HoverSwap.update === 'function') {
        setTimeout(() => window.ES_PDP_HoverSwap.update(), 120);
      }
    } catch(_) {}
  };

  // ---------------------------------------------------------
// ES: Remember the "real selected" swatch image per strip
// so hover-preview can always restore correctly on mouseleave.
// ---------------------------------------------------------
const getSelectedUrlFromStrip = (strip) => {
  if (!strip) return '';
  // 1) remembered (most reliable)
  const remembered = strip.dataset.esSelectedUrl || strip.getAttribute('data-es-selected-url') || '';
  if (remembered) return remembered;

  // 2) checked radio
  let checked = null;
  try { checked = strip.querySelector('input[type="radio"]:checked'); } catch(_) {}
  if (checked) {
    const wrap = checked.closest('.maxus-color');
    const label = wrap && wrap.querySelector('label.color_style2');
    const url = extractBgUrl(label);
    if (url) return upgradeUrl(url, 1200);
  }

  // 3) active class fallbacks (some theme states don't keep radio.checked in sync)
  const active = strip.querySelector('.maxus-color.is-active, .maxus-color.active, .maxus-color.selected');
  if (active) {
    const label = active.querySelector('label.color_style2');
    const url = extractBgUrl(label);
    if (url) return upgradeUrl(url, 1200);
  }

  return '';
};

const rememberSelectedUrl = (strip, url) => {
  if (!strip || !url) return;
  strip.dataset.esSelectedUrl = url;
  try { strip.setAttribute('data-es-selected-url', url); } catch(_) {}
};

const rememberSelectedFromDom = (strip) => {
  const url = getSelectedUrlFromStrip(strip);
  if (url) rememberSelectedUrl(strip, url);
};

const restoreMainImgsFromSelected = (strip) => {
  if (!strip) return;
  const url = strip.dataset.esSelectedUrl || getSelectedUrlFromStrip(strip);
  if (!url) return;
  setMainImgs(strip, url);
};

const bindStripLeave = (strip) => {
  if (!strip || strip.dataset.esLeaveBound) return;
  strip.dataset.esLeaveBound = '1';

  // mouseleave doesn't bubble, so we bind directly to the strip.
  strip.addEventListener('mouseleave', () => {
    try {
      strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview'));
    } catch(_) {}
    restoreMainImgsFromSelected(strip);
  }, true);

};

  // Keep the remembered "real selected" image in sync with actual selection changes
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('.es-swatch-strip input[type="radio"]')) return;

    const strip = t.closest('.es-swatch-strip');
    if (!strip) return;

    // Clear any preview state when a real selection happens
    try { strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview')); } catch(_) {}

    const wrap = t.closest('.maxus-color');
    const label = wrap && wrap.querySelector('label.color_style2');
    const url = extractBgUrl(label);
    if (url) rememberSelectedUrl(strip, upgradeUrl(url, 1200));
  }, true);

  // Prime cache (PDP already has checked by default; Quickview is injected later but this is harmless)
  const primeSelectedCache = () => {
    try {
      // PDP + Quickview both use `.es-swatch-strip`; don't require a specific ancestor
      // because some templates wrap swatches differently.
      document.querySelectorAll('.es-swatch-strip').forEach((strip) => {
        if (!strip.dataset.esSelectedUrl) rememberSelectedFromDom(strip);
      });
    } catch(_) {}
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeSelectedCache, { once: true });
  } else {
    setTimeout(primeSelectedCache, 0);
  }

  if (canHoverPreview) {
    // Product cards (collection/home/search)
    document.addEventListener('mouseover', (e) => {
      const a = e.target && e.target.closest ? e.target.closest('.engoj_select_color a.circle-thumb, .engoj_select_color a.circle') : null;
      if (!a) return;
      // Ignore if moving within the same swatch
      if (e.relatedTarget && a.contains(e.relatedTarget)) return;

      const card = findCard(a);
      if (!card) return;

      // underline animation
      const wrap = a.closest('.engoj_select_color');
      if (wrap) {
        wrap.querySelectorAll('.border_thumbnail.is-preview').forEach((n) => n.classList.remove('is-preview'));
      wrap.querySelectorAll('a.is-preview').forEach((n) => n.classList.remove('is-preview'));
        wrap.querySelectorAll('a.is-preview').forEach((n) => n.classList.remove('is-preview'));

        const parentThumb = a.closest('.border_thumbnail');
        const isActive = (parentThumb && parentThumb.classList.contains('is-active')) || a.classList.contains('active');

        if (!isActive) {
          if (parentThumb) parentThumb.classList.add('is-preview');
          a.classList.add('is-preview');
        }
      }

      const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
      const img1Large = upgradeUrl(img1, 1200);
      preloadThen(img1Large, () => applyImagesFromAnchor(card, a));
    }, true);

    document.addEventListener('mouseout', (e) => {
      const a = e.target && e.target.closest ? e.target.closest('.engoj_select_color a.circle-thumb, .engoj_select_color a.circle') : null;
      if (!a) return;
      const wrap = a.closest('.engoj_select_color');
      if (!wrap) return;

      // If we're moving to another swatch inside the same wrap, don't restore (avoid flicker)
      if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;

      wrap.querySelectorAll('.border_thumbnail.is-preview').forEach((n) => n.classList.remove('is-preview'));
      wrap.querySelectorAll('a.is-preview').forEach((n) => n.classList.remove('is-preview'));
      const card = findCard(a);
      restoreCardImages(card);
    }, true);

    // PDP + Quickview (square swatches with label thumbnails)
    // Use `.es-swatch-strip .maxus-color` instead of requiring `.maxus-productdetail__options` so we
    // reliably restore state even if the swatches are rendered in a different wrapper.
    document.addEventListener('mouseover', (e) => {
      const item = e.target && e.target.closest ? e.target.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;

      const strip = item.closest('.es-swatch-strip');
      if (!strip) return;
      // ensure we can always restore to the true selected swatch
      bindStripLeave(strip);
      if (!strip.dataset.esSelectedUrl) rememberSelectedFromDom(strip);      // underline animation (preview only; real selection still requires click)
      strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview'));

      // Don't show preview state on the already-selected option
      const checked = item.querySelector('input[type="radio"]:checked');
      if (checked) return;

      item.classList.add('is-preview');

      const label = item.querySelector('label.color_style2');
      const url = extractBgUrl(label);
      if (!url) return;
      const urlLarge = upgradeUrl(url, 1200);

      // fadeSwapImg already preloads; keep this light
      setMainImgs(strip, urlLarge);
}, true);

    document.addEventListener('mouseout', (e) => {
      const item = e.target && e.target.closest ? e.target.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;
      const strip = item.closest('.es-swatch-strip');
      if (!strip) return;

      // If moving inside the same swatch item, ignore
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;

      // If moving to another swatch item, let the next hover take over (don't restore yet)
      if (e.relatedTarget && strip.contains(e.relatedTarget)) {
        const nextItem = e.relatedTarget.closest ? e.relatedTarget.closest('.maxus-color') : null;
        if (nextItem) return;
      }

      strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview'));
      restoreMainImgsFromSelected(strip);
    }, true);
  }


  /* =========================================================
     ES FIX: iPad/Tablet PDP swatch reliability
     - iPad uses the mobile header (Bootstrap < xl) and touch input
     - Make the whole swatch item clickable (including the text)
     - Ensure main image updates on selection even without hover
  ========================================================= */
  document.addEventListener('click', function(e){
    try{
      var item = e.target && e.target.closest ? e.target.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;
      var input = item.querySelector('input[type="radio"]');
      if (!input) return;

      // If user taps the color name (not the label), force-select the radio.
      if (!input.checked && e.target.tagName !== 'LABEL') {
        input.click();
      }
    }catch(_){}
  }, true);

  document.addEventListener('change', function(e){
    try{
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var item = input.closest ? input.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;

      // Use the swatch label bg image as a fallback to update the PDP main image.
      var label = item.querySelector('label.color_style2') || item.querySelector('label');
      if (!label) return;
      var url = extractBgUrl(label);
      if (!url) return;

      var strip = item.closest ? item.closest('.es-swatch-strip') : null;
      if (!strip) return;

      rememberSelectedUrl(strip, url);
      setMainImgs(strip, url);
    }catch(_){}
  }, true);



  /* ==========================================================
     ES: Swatch horizontal scroll hint (PDP + any swatch strip)
     - Adds classes to show subtle edge fades only when overflow
     ========================================================== */
  function esInitSwatchScrollHints(){
    var strips = document.querySelectorAll('.es-swatch-strip');
    if (!strips || !strips.length) return;

    var rafMap = new WeakMap();

    function update(strip){
      try{
        var overflow = (strip.scrollWidth - strip.clientWidth) > 2;
        var atStart = strip.scrollLeft <= 1;
        var atEnd = (strip.scrollLeft + strip.clientWidth) >= (strip.scrollWidth - 1);
        var scrolled = strip.scrollLeft > 1;

        strip.classList.toggle('es-overflow', overflow);
        strip.classList.toggle('es-at-start', atStart);
        strip.classList.toggle('es-at-end', atEnd);
        strip.classList.toggle('es-scrolled', scrolled);

        // If not overflow, ensure fades are off
        if (!overflow){
          strip.classList.remove('es-scrolled','es-at-start','es-at-end');
        }
      }catch(_){}
    }

    function schedule(strip){
      if (rafMap.get(strip)) return;
      rafMap.set(strip, true);
      requestAnimationFrame(function(){
        rafMap.delete(strip);
        update(strip);
      });
    }

    strips.forEach(function(strip){
      if (!strip || strip.getAttribute('data-es-scrollhint') === '1') return;
      strip.setAttribute('data-es-scrollhint','1');

      // Initial state
      update(strip);

      // Update on scroll
      strip.addEventListener('scroll', function(){ schedule(strip); }, {passive:true});

      // Update when fonts/images load can change widths
      window.addEventListener('load', function(){ update(strip); }, {once:true});
    });

    // One resize listener for all strips
    var resizeTimer = null;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        strips.forEach(function(strip){ update(strip); });
      }, 120);
    }, {passive:true});
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', esInitSwatchScrollHints);
  }else{
    esInitSwatchScrollHints();
  }


})();
